import { defineField, defineType } from 'sanity'
import { SpecialEventPhaseBlocks } from '../pageBlocks'

export default defineType({
  title: 'Event phase',
  name: 'specialEventPhase',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
      description:
        'Not used on the page, only acts as label for the editor in Sanity Studio.',
    }),
    defineField({
      title: 'Page blocks',
      name: 'pageBlocks',
      type: 'array',
      of: SpecialEventPhaseBlocks,
    }),
    defineField({
      title: 'Start Date',
      name: 'startDate',
      type: 'datetime',
      options: {
        dateFormat: 'YYYY-MM-DD',
        timeFormat: 'HH:mm',
      },
      validation: (rule) => rule.required(),
    }),
  ],
  preview: {
    select: {
      title: 'title',
      startDate: 'startDate',
    },
    prepare({ title, startDate }) {
      return {
        title: title || 'Event Phase',
        subtitle: startDate ? `Starts: ${new Date(startDate).toLocaleDateString()}` : 'Event Phase',
      }
    },
  },
})
